import {
  Box,
  Button,
  ColumnLayout,
  Container,
  DatePicker,
  Form,
  FormField,
  Header,
  Select,
  SelectProps,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { useState } from "react";
import { useAppDispatch } from "../../app/hook";
import {
  InputNames,
  clearFormFieldErrTxt,
} from "../../features/error/validation-slice";
import { createSearchCondition } from "../../features/slices/credit-card-examination-search";
import { formatDate } from "../../utils/format";
import { COMMON_LABELS } from "../default-constants";
import {
  CONFIGS,
  LABELS,
  ORDER_TARGET_LIST_SEARCH,
  STATUS_LIST,
} from "./constants";

const SearchBar = () => {
  // 一覧表示対象ブランド
  const [displayTargetBrand, setDisplayTargetBrand] =
    useState<SelectProps.Option>({
      label: "",
      value: "",
    });

  // 申請期間(開始)
  const [responseDateStart, setResponseDateStart] = useState("");

  // 申請期間(終了)
  const [responseDateEnd, setResponseDateEnd] = useState("");

  // 交渉状況
  const [applicationStatus, setApplicationStatus] = useState({ value: "" });

  // 入力エラー表示用変数
  const selectItem = CONFIGS.SELECT_ITEM as keyof InputNames;

  const dispatch = useAppDispatch();

  //バリデーションチェックエラーメッセージ
  const [applicationStatusErrorMsg, setApplicationStatusErrorMsg] =
    useState("");

  // 検索ボタンイベント
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // イベントキャンセル
    e.preventDefault();
    let responseDateStartSearchLabel = responseDateStart;
    let responseDateEndSearchLabel = responseDateEnd;
    if (responseDateStart !== "") {
      responseDateStartSearchLabel = formatDate(responseDateStart);
    }
    if (responseDateEnd !== "") {
      responseDateEndSearchLabel = formatDate(responseDateEnd);
    }

    dispatch(
      createSearchCondition({
        orderTargetName: displayTargetBrand.label as string,
        applicationStatus: applicationStatus.value,
        responseDateStart: responseDateStartSearchLabel,
        responseDateEnd: responseDateEndSearchLabel,
        timestamp: new Date().getTime(),
      })
    );
    //エラーメッセージクリア;
    setApplicationStatusErrorMsg("");
  };

  // ドロップダウン表示アイテムリストの作成処理
  const createSelectItemList = () => {
    let selectItemList: SelectProps.Option[] = [];
    let blankItem = {
      label: "　",
      value: "0",
    } as SelectProps.Option;

    for (const item of ORDER_TARGET_LIST_SEARCH) {
      const selectItem = {
        label: item.label,
        value: item.value,
      } as SelectProps.Option;

      selectItemList.push(selectItem);
    }
    selectItemList.unshift(blankItem);

    return selectItemList;
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal">{COMMON_LABELS.BTNS.SEARCH}</Button>
          </SpaceBetween>
        }
      >
        <Container
          header={<Header variant="h2">{LABELS.ANSWER_STATUS_TITLE}</Header>}
        >
          <SpaceBetween direction="vertical" size="xxl">
            <ColumnLayout columns={4}>
              <FormField
                label={LABELS.ORDER_TARGET_NAME}
                errorText={applicationStatusErrorMsg}
              >
                <Select
                  selectedOption={displayTargetBrand}
                  options={createSelectItemList()}
                  filteringType="none"
                  onChange={(event: any) => {
                    dispatch(clearFormFieldErrTxt(selectItem));
                    setDisplayTargetBrand(event.detail.selectedOption);
                  }}
                />
              </FormField>
            </ColumnLayout>
            <SpaceBetween direction="horizontal" size="xs">
              <FormField label={LABELS.APPLICATION_PERIOD}>
                <DatePicker
                  onChange={({ detail }) => setResponseDateStart(detail.value)}
                  value={responseDateStart}
                  openCalendarAriaLabel={(selectedDate) =>
                    "Choose certificate expiry date" +
                    (selectedDate ? `, selected date is ${selectedDate}` : "")
                  }
                  nextMonthAriaLabel="Next month"
                  placeholder="YYYY/MM/DD"
                  previousMonthAriaLabel="Previous month"
                  todayAriaLabel="Today"
                />
              </FormField>
              <Box padding={{ top: "xxl" }} variant="awsui-key-label">
                {LABELS.FROM}
              </Box>
              <FormField label={LABELS.EMPTY}>
                <DatePicker
                  onChange={({ detail }) => setResponseDateEnd(detail.value)}
                  value={responseDateEnd}
                  openCalendarAriaLabel={(selectedDate) =>
                    "Choose certificate expiry date" +
                    (selectedDate ? `, selected date is ${selectedDate}` : "")
                  }
                  nextMonthAriaLabel="Next month"
                  placeholder="YYYY/MM/DD"
                  previousMonthAriaLabel="Previous month"
                  todayAriaLabel="Today"
                />
              </FormField>
            </SpaceBetween>
            <ColumnLayout columns={4}>
              <FormField label={LABELS.APPLICATION_STATUS}>
                <Select
                  selectedOption={applicationStatus}
                  options={STATUS_LIST}
                  filteringType="none"
                  onChange={(event: any) => {
                    setApplicationStatus(event.detail.selectedOption);
                  }}
                />
              </FormField>
            </ColumnLayout>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default SearchBar;
